export default () => ({
    showBar: false,
    page: location.pathname.split('/')[location.pathname.split('/').length - 1], 
    mobile: window.matchMedia('only screen and (max-width: 760px)').matches,
    intro: true,
    scroll: 0,
    flyout: false,
    filter: 'All',
    practice: null,
    projectInfo: false,
    introtimeout: null,

    openInfo: function() {
        this.$refs.modal.classList.add('active');
        this.$refs.close.classList.add('active');
        this.projectInfo = true;
    },

    closeInfo: function() {
        this.$refs.modal.classList.remove('active');
        this.$refs.close.classList.remove('active');
        this.projectInfo = false;
    },

    clearIntro: function() {
        console.log('clearIntro');
        // this.introtimeout = null;
        var id = window.setTimeout(function() {}, 0);
        while (id--) {
            window.clearTimeout(id); // will do nothing if no timeout with id is present
        }
    },

    loadIntro: function() {

        if(window.location.pathname == '/') {
            console.log('loadIntro');
            // fade in the logo first
            // console.log(this.$refs.header);
            this.$refs.header.classList.add('out');
            this.$refs.header.classList.add('home');

            setTimeout(() => {
                this.$refs.introLogo.classList.add('in');
            }, 1000);

            // then switch from the logo slide to the strapline slide
            setTimeout(() => {
                this.$refs.introLogo.classList.add('out');
                this.$refs.introLogo.classList.remove('in');
                this.$refs.introStrapline.classList.add('in');
            }, 2500);
            setTimeout(()=> {
                this.$refs.introStrapline.classList.remove('in');
            }, 3500);

            setTimeout(() => {
                this.$refs.introGallery.classList.remove('out');
                this.$refs.introGallery.classList.add('in');
            }, 4000);

            setTimeout(() => {
                this.$refs.header.classList.remove('out');
                // this.$refs.header.classList.remove('home');
            }, 4700);
            
            this.introtimeout = setTimeout(() => { 

                let index = 1;
                let counter = 500;
                var galleryCycle = function() {
                    counter = index % 3 == 0 ? 3000 : 3000;
                    console.log('slidechange: ' + index);
                    setTimeout(galleryCycle, counter);
                    // change active slide
                    document.querySelectorAll('.intro_gallery ul li').forEach((slide) => {
                        slide.classList.remove('active');
                    });
                    document.querySelectorAll('.intro_gallery ul li')[index - 1].classList.add('active');
                    if(index > document.querySelectorAll('.intro_gallery ul li').length - 1) {
                        index = 1;
                    } else {
                        index++;
                    }

                }
                this.introtimeout = setTimeout(galleryCycle, counter);
                
            }, 4000);
            

            // fade out the entire intro block
            // setTimeout(() => {
            //     this.$refs.intro.classList.add('out');
            // }, 4000)
            
            // reset the classes to the default
            // setTimeout(() => {
            //     this.$refs.introLogo.classList.remove('out');
            //     this.$refs.introStrapline.classList.remove('in');
            // }, 4500)
        } else {
            this.$refs.intro.classList.add('out');
        }
        
      
      
    },
})